export default function MerchantAddController(
  $state,
  $stateParams,
  DestinationService,
  countryService,
  merchantService,
  NotificationService,
  merchantCategoriesService,
  UtilService,
  searchTagsService,
  MERCHANT_PRODUCTS,
  DESTINATION_TYPES,
  SEARCH_TAGS_TYPES,
  MERCHANT_CONSTANTS,
  NgMap,
  googleMapsHelper,
) {
  const vm = this;
  const PRODUCT_STATE_PARAM_NAME = 'product';

  vm.merchantAddForm = 'merchantAddForm';
  vm.googleMapsUrl = googleMapsHelper.getApiUrl();
  vm.isLoading = false;
  vm.merchantProducts = MERCHANT_PRODUCTS;
  vm.merchantCoreProducts = [
    MERCHANT_PRODUCTS.FREE_PLUS,
    MERCHANT_PRODUCTS.MERCHANT_CENTER_BASIC,
    MERCHANT_PRODUCTS.PROFESSIONAL_WEB,
    MERCHANT_PRODUCTS.PREMIUM_MERCHANT,
    MERCHANT_PRODUCTS.PROSPECT,
  ];
  vm.merchantCoreProductsSpecialTypes = [MERCHANT_PRODUCTS.LISTING_NON_PARTNER_RESTAURANT];
  vm.coreProductType = MERCHANT_PRODUCTS.FREE_PLUS; // pre-select Free Plus product
  vm.additionalProductType = {};
  vm.countryId = null;
  vm.regionId = null;
  vm.cityId = null;
  vm.districtId = null;
  vm.priceTags = [];
  vm.merchantPriceTag = {};
  vm.semBusinessNameCharLimit = MERCHANT_CONSTANTS.SEM_BUSINESS_NAME_LIMIT;
  vm.merchant = {
    name: '',
    homepage: '',
    phoneNumber: '',
    email: '',
    address: {
      streetName: '',
      zipcode: '',
      city: '',
    },
    latitude: '',
    longitude: '',
    test: false,
    sortOrder: 0,
    searchTags: [],
  };
  vm.options = {
    countries: [],
    regions: [],
    cities: [],
    districts: [],
  };

  vm.PRICES_TAGS_NAMES = SEARCH_TAGS_TYPES.PRICES_TAGS_NAMES;
  //TODO manage PriceTags by id once attribute to tags migration done

  vm.init = init;
  vm.getRegions = getRegions;
  vm.getCities = getCities;
  vm.getDistricts = getDistricts;
  vm.updateDestinationId = updateDestinationId;
  vm.updateCityField = updateCityField;
  vm.addMerchant = addMerchant;
  vm.mapMarkerDragEnd = mapMarkerDragEnd;
  vm.autocompleteFields = autocompleteFields;
  vm.updateMerchantTags = updateMerchantTags;
  vm.updateMerchantPriceTag = updateMerchantPriceTag;
  vm.copyNameToSemBusinessNameField = copyNameToSemBusinessNameField;
  vm.onSemBusinessNameChange = onSemBusinessNameChange;

  init();

  function init() {
    checkInputParams();
    getCountries();
    getPriceTags();
  }

  function checkInputParams() {
    if ($stateParams) {
      angular.forEach($stateParams, (value, key) => {
        if (key === PRODUCT_STATE_PARAM_NAME) {
          vm.coreProductType = parseInt(value, 10);
        }
        if (vm.merchant.hasOwnProperty(key)) {
          vm.merchant[key] = value;
        } else if (vm.merchant.address.hasOwnProperty(key)) {
          vm.merchant.address[key] = value;
        }
      });
    }
    NgMap.getMap().then(function(map) {
      vm.map = map;
    });
    formatForPrefill();
  }

  function formatForPrefill() {
    if ($stateParams.streetAndNumber && $stateParams.zipcode) {
      vm.address = $stateParams.streetAndNumber + ' ' + $stateParams.zipcode;
    }
    vm.merchant.homepage = $stateParams.homepage;
  }

  function getCountries() {
    countryService.getAllCountries().then(function(res) {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getRegions() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.REGION.name,
      status: 'active',
    };
    if (!vm.countryId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.countryId, params).then(function(res) {
      vm.options.regions = res.data;
      vm.options.cities = [];
      vm.options.districts = [];
      vm.destinationId = null;
    });
  }

  function getCities() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.CITY.name,
      status: 'active',
    };
    if (!vm.regionId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.regionId, params).then(function(res) {
      vm.options.cities = res.data;
      vm.options.districts = [];
      vm.destinationId = null;
    });
  }

  function getDistricts() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.DISTRICT.name,
      status: 'active',
    };
    if (!vm.cityId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.cityId, params).then(function(res) {
      vm.options.districts = res.data;
    });
  }

  function updateDestinationId() {
    if (vm.options.districts.length) {
      vm.merchant.destinationId = vm.districtId;
    } else {
      vm.merchant.destinationId = vm.cityId;
    }
  }

  function updateCityField() {
    vm.merchant.address = vm.merchant.address || {};
    if (vm.cityId) {
      angular.forEach(vm.options.cities, function(value) {
        if (value.id === vm.cityId) {
          vm.merchant.address.city = value.name;
        }
      });
    } else {
      vm.merchant.address.city = '';
    }
  }

  function getSelectedProductIds() {
    const selectedProductIds = [],
      isCoreProduct = vm.merchantCoreProducts.indexOf(vm.coreProductType) !== -1,
      isSpecialProduct = vm.merchantCoreProductsSpecialTypes.indexOf(vm.coreProductType) !== -1,
      isFreePlus = vm.coreProductType === vm.merchantProducts.FREE_PLUS;

    if (vm.coreProductType) {
      selectedProductIds.push(vm.coreProductType);
    }
    if (isCoreProduct && vm.additionalProductType.listingPartner) {
      selectedProductIds.push(vm.merchantProducts.LISTING_PARTNER_RESTAURANT);
    }
    if (isCoreProduct && vm.additionalProductType.bookingWidget) {
      selectedProductIds.push(vm.merchantProducts.BOOKING_WIDGET);
    }
    if (isSpecialProduct && vm.additionalProductType.bookingMessage) {
      selectedProductIds.push(vm.merchantProducts.BOOKING_MESSAGE);
    }
    return selectedProductIds;
  }

  function getPriceTags() {
    searchTagsService.getAllTags().then(res => {
      if (res.data) {
        vm.priceTags = res.data.searchTags.filter(tag => tag.tagType === SEARCH_TAGS_TYPES.PRICE);
      }
    });
  }

  function updateMerchantTags(tags) {
    vm.merchant.searchTags = tags;
    vm.isMainCuisineTagSelected = vm.merchant.searchTags.find(tag => tag.primary);
  }

  function updateMerchantPriceTag(tagName) {
    vm.selectedPriceTag = vm.priceTags.find(tag => tag.name === tagName);

    const tagPriceIndex = vm.merchant.searchTags.findIndex(tag => tag.tagType === SEARCH_TAGS_TYPES.PRICE);
    const newMerchantTags = angular.copy(vm.merchant.searchTags);
    if (tagPriceIndex > -1) {
      newMerchantTags[tagPriceIndex] = vm.selectedPriceTag;
    } else {
      newMerchantTags.push(vm.selectedPriceTag);
    }

    vm.merchant.searchTags = newMerchantTags;
  }

  function copyNameToSemBusinessNameField() {
    if (!vm.merchant.semBusinessName && vm.merchant.name) {
      vm.merchant.semBusinessName = vm.merchant.name.substring(0, MERCHANT_CONSTANTS.SEM_BUSINESS_NAME_LIMIT);
    }
  }

  function onSemBusinessNameChange(semBusinessName) {
    vm.merchant.semBusinessName = semBusinessName;
    vm.merchantAddForm.$setDirty();
  }

  function addMerchant() {
    if (vm.isLoading) {
      return;
    }

    vm.isLoading = true;
    vm.merchant.productIds = getSelectedProductIds();
    const merchant = Object.assign({}, vm.merchant);
    merchant.emails = merchant.emails.split(',').map( email =>  email.trim());

    merchantService
      .addMerchant(merchant)
      .then(function(res) {
        const merchantId = getMerchantIdFromLocationHeader(res.headers('location'));
        NotificationService.success('Congratulations you have created a new merchant ' + vm.merchant.name);
        $state.go('app.merchant', {
          merchantId: merchantId,
          retryOn404: true,
        });
      })
      .catch(function(res) {
        const error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? error.message : 'Creating new merchant failed';
        NotificationService.error(errorMessage);
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function getMerchantIdFromLocationHeader(locationHeader) {
    return locationHeader.split('/').pop();
  }

  function mapMarkerDragEnd(e) {
    googleMapsHelper.setLatLng(e, vm.merchant);
  }

  function autocompleteFields() {
    vm.place = this.getPlace();

    if (!vm.place.geometry) {
      return;
    }

    const fieldsToComplete = [
      {
        gField: 'route',
        ocField: 'streetName',
      },
      {
        gField: 'postal_code',
        ocField: 'zipcode',
      },
      {
        gField: 'street_number',
        ocField: 'streetNumber',
      },
      {
        gField: 'locality',
        ocField: 'city',
      },
    ];

    vm.merchant.latitude = vm.place.geometry.location.lat();
    vm.merchant.longitude = vm.place.geometry.location.lng();

    vm.place.address_components.forEach(function(address) {
      fieldsToComplete.forEach(function(field) {
        if (field.gField === address.types[0]) {
          vm.merchant.address[field.ocField] = address.long_name;
        }
      });
    });
    vm.map.setCenter(vm.place.geometry.location);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchant-add.controller.js